import { CModalBody } from "@coreui/react";
import { useRef, useState } from "react";
import { ButtonBasic, TextButton } from "src/components";
import { useDispatch, useSelector } from "react-redux";
import { setTrackerModalShow } from "src/store/trackerSlice";
import { useEsgEmails } from "src/features/esg-survey/hooks";
import { selectOrgData } from "src/store/projectSelectors";
import { useUser } from "reactfire";

const PreValidation = () => {
  const { sendEsgSubmittedForValidationEmail } = useEsgEmails();

  const { validationEmailSent, email } = useSelector(selectOrgData);

  const { data: user } = useUser();

  const linkRef = useRef(null);

  const [sending, setSending] = useState(false);

  const goToPayment = async () => {
    if (!validationEmailSent) {
      try {
        setSending(true);
        await sendEsgSubmittedForValidationEmail({
          respondentId: user.uid,
          email: email,
          name: user.displayName,
        });
      } catch (error) {
        console.log("error sending email", error);
      } finally {
        setSending(false);
      }
    }

    linkRef.current.click();
  };

  const dispatch = useDispatch();

  const openTracker = () => {
    dispatch(setTrackerModalShow(true));
  };

  return (
    <CModalBody className="text-justify">
      <p>
        Once you've uploaded your{" "}
        <TextButton
          className="text-info"
          style={{
            fontSize: "16px",
            fontWeight: "bold",
          }}
          onClick={openTracker}
        >
          {" "}
          evidence
        </TextButton>
        , it's time to submit your score for validation and pay the fee for
        validation.
      </p>
      <p>
        We'll assign you an analyst with 2 working days, and they'll be in touch
        over the next 2 weeks to ask for clarifications or further evidence - by
        email and potentially scheduling a call where needed. Please feel free
        to request a call at this stage once you have the details of your
        analyst.
      </p>
      <p>
        Your analyst will assess your evidence and proposed score against our
        framework any dviergence - where evidence is insufficient or even where
        you may score better than you proposed. These areas of difference will
        form the basis for analyst follow up, and you'll have an opportunity to
        submit further evidence or discuss the question further with the
        analyst. You can escalate issues with ZeroBees upon request, but the
        decision of the escalation manager is final.
      </p>
      <p>
        Expect validation to take around 3 weeks from submission, though this
        time may be shorter or longer depending on the evidence you've submitted
        and number of organisations going through accreditation.
      </p>
      <div className="d-flex justify-content-center w-100 mt-4">
        <ButtonBasic
          size="lg"
          bgcolor="green"
          hovercolor="darkgreen"
          onClick={goToPayment}
          disabled={sending}
          active
          tabIndex={-1}
        >
          {sending ? "Please wait..." : "Submit & Pay"}
        </ButtonBasic>
        <a
          href="https://www.zerobees.com/bit-payment"
          target="_blank"
          rel="noreferrer"
          alt=""
          ref={linkRef}
          style={{
            visibility: "hidden",
          }}
        >
          Pay
        </a>
      </div>
    </CModalBody>
  );
};

export default PreValidation;
